import { SvgIcon, type SvgIconProps } from './svgIcon'

type Props = SvgIconProps & {
  width?: number
  height?: number
  fontSize?: number
  primaryColor?: string
  secondaryColor?: string
  strokeWidth?: number
}

export function FaceIconSmiley({
  width = 185,
  height = 185,
  fontSize = 185,
  primaryColor = '#E3E3E3',
  secondaryColor = '#006EF0',
  strokeWidth = 4,
  ...props
}: Props) {
  return (
    <SvgIcon
      width={width}
      height={height}
      style={{ fontSize }}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M182 92C182 121.93 167.39 148.45 144.9 164.82C130.05 175.63 111.77 182 92 182C72.23 182 53.95 175.62 39.1 164.82C16.61 148.46 2 121.93 2 92C2 82.29 3.54 72.94 6.38 64.18C18.1 28.09 52 2 92 2C132 2 165.9 28.09 177.62 64.18C180.46 72.94 182 82.29 182 92Z"
        stroke={secondaryColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <circle cx="63.8584" cy="69.8154" r="9.81541" fill={primaryColor} />
      <circle cx="120.294" cy="69.8154" r="9.81541" fill={primaryColor} />
      <path
        d="M130.73 108.27C109.34 129.66 74.6601 129.66 53.2703 108.27"
        stroke={primaryColor}
        strokeWidth={strokeWidth * 2.5}
      />
    </SvgIcon>
  )
}
